import React from "react";
import { ReactComponent as BedDoubleSvg } from "../svg/bed-double.svg";

export default function BedIcon({ size = 64, color = "#32363F", ...props }) {
  return <BedDoubleSvg width={size} height={size} style={{ color }} {...props} />;
}
